import { render, staticRenderFns } from "./AnkiModalBody.vue?vue&type=template&id=1e16bd92&lang=pug&"
import script from "./AnkiModalBody.vue?vue&type=script&lang=js&"
export * from "./AnkiModalBody.vue?vue&type=script&lang=js&"
import style0 from "./AnkiModalBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports